<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2020-07-06 14:33:55
 * @FilePath: /mrc_ess_web_fronted/src/Layout/components/MsgStatus.vue
 * @最后编辑: Betway
 * @最后修改时间: 2020-09-16 10:06:10
-->
<template>
  <div>
    <v-snackbar
      v-model="MsgStatus.show"
      bottom
      class="animated slideInUp"
      :color="MsgStatus.color"
      :timeout="2400"
      @input="hideMessage"
    >
      {{ MsgStatus.text }}
      <!-- <template v-slot:action="{ attrs }">
        <v-btn icon @click="$hideMessage" v-bind="attrs">
          <span class="material-icons-round">
            highlight_off
          </span>
        </v-btn>
      </template>-->
    </v-snackbar>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "StatusMessage",
  computed: {
    ...mapGetters(["MsgStatus"]),
  },
  methods: {
    hideMessage: function () {
      this.$hideMessage();
    },
  },
};
</script>
